<template>
  <div style="padding: 20px">
    <div style="background-color: #FFFFFF;border-radius: 8px;padding: 24px;max-height: 1160px;overflow-y: auto">
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-input v-model="query.name" placeholder="请输入名称" style="width: 300px"></el-input>
          <el-button type="primary" style="margin-left: 15px" @click="getList">搜索</el-button>
        </div>
        <div>
          <el-button type="success" @click="add">添加</el-button>
        </div>
      </div>
      <div style="border: 1px solid #e6ebf2;border-radius: 6px;margin-top: 20px;border-bottom: none">
        <el-table
          :data="table_data.list"
          :header-cell-style="{ backgroundColor: '#f5f7fa' }"
          style="border-radius: 6px"
        >
          <el-table-column prop="id" label="ID">
            <template #header>
              <div style="padding-left: 24px;">ID</div>
            </template>
            <template #default="scope">
              <div style="padding-left: 24px;">{{ scope.row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="template_name" label="模版名称" />
          <el-table-column prop="description" label="投放类型">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.project_param.delivery_mode === 'PROCEDURAL'" type="primary">自动投放</el-tag>
              <el-tag v-else type="success">手动投放</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
<!--              <span class="action-btn" style="color: #165DFF" @click="edit(scope.row)">修改</span>-->
              <span class="action-btn" style="color: #F53F3F" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination-right
        :total="table_data.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>

import { adTemplateList, setupTemplateDel } from '@/api/customer'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10
      },
      table_data: {
        total: 0,
        list: []
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      adTemplateList(this.query).then((res) => {
        console.log(res)
        this.table_data = res.data
      })
    },
    add() {
      this.$router.push('/massiveAdvertisingAD/addAdvertisingTemplate/index')
    },
    del(val) {
      console.log(val)
      setupTemplateDel({ id: val.id }).then(res => {
        console.log(res)
      })
    },
    edit(val) {
      console.log(val)
      this.$router.push('/massiveAdvertisingAD/addAdvertisingTemplate/index')
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.getList()
    }
  }
}
</script>

<style scoped>
.action-btn {
  cursor: pointer;
  color: #409EFF;
  margin: 0 10px;
  transition: color .2s;
}
.action-btn:hover {
  opacity: .8;
}
</style>
